import { DateTime, Settings } from 'luxon';

export const TIMEZONE = 'America/Sao_Paulo';

Settings.defaultZone = TIMEZONE;
Settings.defaultLocale = 'pt-br';

export const DateFromFormat = (date: string, fromFormat: string): string => {
  return DateTime.fromFormat(date, fromFormat).toFormat("yyyy-MM-dd'T'HH:mm:ss");
};

export const SimpleDateFormat = (date: string, fromFormat: string): string => {
  return DateTime.fromFormat(date, fromFormat).toFormat('dd/MM/yyyy');
};

export const DateFromIso = (date: string): string => {
  return DateTime.fromISO(date).toFormat("yyyy-MM-dd'T'HH:mm:ss");
};

export const DateFromISOToBrazilianFormat = (date: string): string => {
  return DateTime.fromISO(date).toFormat('dd/MM/yyyy');
};

export const DateFromJSDate = (date: Date): string => {
  return DateTime.fromJSDate(date).toFormat("yyyy-MM-dd'T'HH:mm:ss");
};

export const DateFromJSDateToBrazilianFormat = (date: Date): string => {
  return DateTime.fromJSDate(date, { zone: TIMEZONE }).toFormat('dd/MM/yyyy');
};

export const getMonthFromIso = (date: string): string | null => {
  return DateTime.fromISO(date).monthLong;
};

export const getMonthFromJSDate = (date: Date): string | null => {
  return DateTime.fromJSDate(date).monthLong;
};

export const getMonthFromFormat = (date: string, fromFormat: string): string | null => {
  return DateTime.fromFormat(date, fromFormat).monthLong;
};

export const getHourAndMinuteFromIso = (date: string): string => {
  return DateTime.fromISO(date, { zone: 'UTC' }).toFormat('HH:mm');
};

export const joinDateWithHourAndMinutes = (date: string, hourAndMinute?: string) => {
  if (!hourAndMinute) return DateTime.fromFormat(date, 'dd/MM/yyyy', { zone: 'UTC' }).toFormat("yyyy-MM-dd'T'HH:mm:ss");

  const time = {
    hours: parseInt(hourAndMinute),
    minutes: parseInt(hourAndMinute.split(':')[1].trim()),
  };

  return DateTime.fromFormat(date, 'dd/MM/yyyy', { zone: 'UTC' })
    .plus({ hours: time.hours, minutes: time.minutes })
    .toFormat("yyyy-MM-dd'T'HH:mm:ss");
};

const extractDate = (
  dt: Date
): {
  year: number;
  month: number;
  day: number;
} => {
  return {
    year: dt.getFullYear(),
    month: dt.getMonth(),
    day: dt.getDate(),
  };
};

export const dateOneGreaterThanDateTwo = (dateOne: Date, dateTwo: Date): boolean => {
  const extractedDateOne = extractDate(dateOne);
  const extractedDateTwo = extractDate(dateTwo);

  const dateOnlyOne: Date = new Date(extractedDateOne.year, extractedDateOne.month, extractedDateOne.day);
  const dateOnlyTwo: Date = new Date(extractedDateTwo.year, extractedDateTwo.month, extractedDateTwo.day);

  return dateOnlyOne.getTime() > dateOnlyTwo.getTime();
};
